module.exports = __webpack_public_path__ + "img/80.3c1a735b.jpg";